import React from 'react';
import PropTypes from "prop-types";

const NUMBERONLY_DEFAULT_PLACEHOLDER = '';
const NUMBERONLY_DEFAULT_MAX_LENGTH = 10;


function NumberOnlyField({component_data, answer, itemData, inputKey, onChange}) {
    const maxLength = _.get(component_data, 'config.max_length', NUMBERONLY_DEFAULT_MAX_LENGTH);
    const value = _.get(answer, ['answer_selections', inputKey], '');
    const style = _.get(itemData, 'style');
    const placeholder = _.get(itemData, 'placeholder', NUMBERONLY_DEFAULT_PLACEHOLDER);

    return (
        <input
            className="cc-numberonly-item-input"
            type="text"
            value={value ?? ''}
            placeholder={placeholder}
            onChange={onChange}
            maxLength={maxLength}
            style={style}
        />
    );
}

NumberOnlyField.propTypes = {
    component_data: PropTypes.object.isRequired,
    answer: PropTypes.object.isRequired,
    itemData: PropTypes.object.isRequired,
    inputKey: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default NumberOnlyField
